import { redirect, type LoaderFunctionArgs } from 'react-router';
import { analyserCodeEtiquette } from '@artosera/shared';
import { reserveApi, type ResolutionEtiquette } from '../../api/reserve.js';
import { estApiError } from '../../api/errors.js';
import { adresseDeRetour } from '../../auth/retour.js';
import { exigerSession } from '../loaders.js';

export type ResultatEtiquette = { raison: 'inconnue' | 'perimee' };

function destination(slug: string, { cible, resume }: ResolutionEtiquette): string {
  switch (cible.type) {
    case 'oeuvre':
      return `/${slug}/oeuvres/${cible.id}`;
    case 'exemplaire':
      return `/${slug}/oeuvres/${'oeuvreId' in resume ? resume.oeuvreId : ''}`;
    case 'caisse':
      return `/${slug}/inventaire/caisses/${cible.id}`;
    case 'emplacement':
      return `/${slug}/reglages/emplacements/${cible.id}`;
  }
}

/**
 * `/e/:jeton` : l'adresse qu'encode le QR d'une étiquette interne, scannée à
 * l'appareil photo. Sans session, la connexion ramène ici ; ensuite, le jeton
 * se résout dans chaque galerie du compte jusqu'à la bonne, puis la fiche
 * s'ouvre. Le jeton ne désigne rien hors de la galerie qui l'a émis.
 */
export async function ouvrirEtiquetteLoader({
  request,
  params,
}: LoaderFunctionArgs): Promise<ResultatEtiquette> {
  const session = await exigerSession(adresseDeRetour(request.url));
  const jeton = analyserCodeEtiquette(params['jeton'] ?? '');
  if (!jeton) return { raison: 'inconnue' };
  let perimee = false;
  for (const { slug } of session.galeries) {
    if (!slug) continue;
    let resolution: ResolutionEtiquette;
    try {
      resolution = await reserveApi.resoudre(slug, jeton);
    } catch (erreur) {
      // Inconnue ici, ou pas le droit de la lire : la galerie suivante.
      if (!estApiError(erreur) || erreur.status >= 500) throw erreur;
      if ((erreur.details as { raison?: string } | null)?.raison === 'etiquette_perimee')
        perimee = true;
      continue;
    }
    throw redirect(destination(slug, resolution));
  }
  return { raison: perimee ? 'perimee' : 'inconnue' };
}
